import React, { useMemo } from 'react';
import type { StudentHistoryMessage } from '../../../types/studentHistory';
import { buildTimelineItems } from '../utils';
import MessageDayDivider from './MessageDayDivider';
import MessageGroup from './MessageGroup';
import styles from './MessageList.module.css';

interface MessageListProps {
  messages: StudentHistoryMessage[];
}

const MessageList: React.FC<MessageListProps> = ({ messages }) => {
  const timelineItems = useMemo(() => buildTimelineItems(messages), [messages]);

  return (
    <div className={styles.container}>
      {timelineItems.map((item) => {
        if (item.type === 'day-divider') {
          return <MessageDayDivider key={item.id} dayKey={item.dayKey} />;
        }

        return <MessageGroup key={item.id} group={item.group} />;
      })}
    </div>
  );
};

export default MessageList;
